import { render, staticRenderFns } from "./partnerMaintainerShareMoney.vue?vue&type=template&id=101c84db&scoped=true&"
import script from "./partnerMaintainerShareMoney.vue?vue&type=script&lang=js&"
export * from "./partnerMaintainerShareMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101c84db",
  null
  
)

export default component.exports